import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate , useLocation} from 'react-router-dom';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import HairstyleGallery from './pages/HairstyleGallery';
import HairstyleBlog from './pages/HairstyleBlog';
import TryOn from './pages/TryOn';
import Login from './pages/Login';
import SignUp from './pages/SignUp';
import UserDashboard from './pages/UserDashboard';
import AdminPanel from './pages/AdminPanel';
import Success from './pages/Success';
import NotFound from './pages/NotFound';
import ProtectedRoute from './components/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext';
import Contact from './pages/Contact';
import Blog from './pages/Blog';
import TermsOfUse from './pages/legal/TermsOfUse';
import PrivacyPolicy from './pages/legal/PrivacyPolicy';
import CookiePolicy from './pages/legal/CookiePolicy';
import Disclaimer from './pages/legal/Disclaimer';
import VerifyEmail from './pages/VerifyEmail';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PopupForm from './components/PopupForm';
import ChatWidget from './components/ChatWidget';
import FluxTool from './pages/FluxTool';
import Review from './pages/Review';
import Sales from './pages/Sales';
import { useState , useEffect} from 'react';
import './index.css';

function AppRoutes() {
  const { user } = useAuth();

  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route 
        path="/try-on" 
        element={
          <ProtectedRoute>
            <TryOn />
          </ProtectedRoute>
        } 
      />
      <Route 
        path="/login" 
        element={user ? <Navigate to="/dashboard" replace /> : <Login />} 
      />
      <Route 
        path="/signup" 
        element={user ? <Navigate to="/dashboard" replace /> : <SignUp />} 
      />
      <Route path="/studio-hair-salon" element={<HairstyleGallery />} />
      <Route path="/studio-hair-salon/:name" element={<HairstyleBlog />} />
      <Route path="/hairstyle/:id" element={<Navigate to="/studio-hair-salon" replace />} />
      <Route path="/success" element={<Success />} />
      <Route path="/hairstyle-try-on-with-ai" element={<Sales />} />
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <UserDashboard />
          </ProtectedRoute>
        }
      />
      <Route path="/contact" element={<Contact />} />
      <Route path="/ai-hairstyle-reviews" element={<Review />} />
      <Route path="/hairstyles" element={<Blog />} />
      <Route path="/hairstyles/:slug" element={<Blog />} />
      <Route path="/legal/terms" element={<TermsOfUse />} />
      <Route path="/legal/privacy" element={<PrivacyPolicy />} />
      <Route path="/legal/cookies" element={<CookiePolicy />} />
        <Route path="/legal/disclaimer" element={<Disclaimer />} />
      <Route path="/random-hairstyle-generator" element={<FluxTool />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute>
            {user?.is_admin ? <AdminPanel /> : <Navigate to="/dashboard" replace />}
          </ProtectedRoute>
        }
      />
      <Route path="/verify-email" element={<VerifyEmail />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}


function LayoutWrapper({ onNewsletterClick, showPopup, setShowPopup }) {
  const location = useLocation(); // Now it's inside Router
  const hideNavbar = location.pathname === "/ai-hairstyle-reviews"; // Hide navbar for /review
  const [isEmbeddedExternally, setIsEmbeddedExternally] = useState(false);

    useEffect(() => {
        try {
            if (window.self !== window.top) {
                // Check if embedded in another site (cross-origin)
                setIsEmbeddedExternally(true);
            }
        } catch (e) {
            // If we get an error, it means we are embedded in a different origin
            setIsEmbeddedExternally(true);
        }
    }, []);

  return (
    <>
      <ScrollToTop />
      { <Navbar onNewsletterClick={onNewsletterClick} />}
        {/* {!hideNavbar && <Navbar onNewsletterClick={onNewsletterClick} />} */}
      {!isEmbeddedExternally && <ChatWidget />}
      <div className={`flex flex-col min-h-screen ${hideNavbar ? "pt-16" : "pt-16"}`}>
        <main className="flex-grow">
          <AppRoutes />
        </main>
        {!isEmbeddedExternally && <Footer />}
      </div>
      {showPopup && <PopupForm onClose={() => setShowPopup(false)} />}
    </>
  );
}

function App() {
  const [showPopup, setShowPopup] = useState(false);

  return (
    <Router>
      <AuthProvider>
        <LayoutWrapper
          onNewsletterClick={() => setShowPopup(true)}
          showPopup={showPopup}
          setShowPopup={setShowPopup}
        />
      </AuthProvider>
    </Router>
  );
}

export default App;
